module.exports = __webpack_public_path__ + "img/lv16.832cf9de.png";